module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"access logs":"Access logs","configs":"Configs","show access configs":"show configs","show access logs":"show access logs"},"de":{"access logs":"Zugangsprotokoll","configs":"Einstellungen","show access configs":"zeige Zugangs Einstellungen","show access logs":"zeige Zugangsprotokoll"}}')
  delete Component.options._Ctor
}
